import React from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import Home from './pages/Home'
import LoginRouter from './pages/LoginRouter'
import SignOut from './pages/SignOut'
import CreatedFeedback from './pages/auth/CreatedFeedback'
import FeedbackForm from './pages/auth/FeedbackForm'
import SelectCanvasBoard from './pages/auth/SelectCanvasBoard'
import FeedbackList from './pages/auth/FeedbackList'
import ApiService from './services/ApiService'
import FeedbackCanvasRender from './pages/auth/FeedbackCanvasRender'
import FeedbackShow from './pages/auth/FeedbackShow'
import FeedbackInvitation from './pages/auth/FeedbackInvitation'
import Profile from './pages/Profile'
import HotjarProvider from './components/HotjarProvider'
import './App.scss'

const App = (): React.JSX.Element => {
  const navigate = useNavigate()
  const location = useLocation()

  ApiService.initialize(navigate, location)

  return (
    <HotjarProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login_router_callback" element={<LoginRouter />} />
        <Route path="/sign_out" element={<SignOut />} />
        <Route path="/feedbacks" element={<FeedbackList />} />
        <Route path="/feedbacks/:id/canvas" element={<FeedbackCanvasRender />} />
        <Route path="/feedbacks/new" element={<SelectCanvasBoard />} />
        <Route path="/feedbacks/new/form" element={<FeedbackForm />} />
        <Route path="/feedbacks/:id/edit" element={<FeedbackForm />} />
        <Route path="/feedbacks/:id/show" element={<FeedbackShow />} />
        <Route path="/feedbacks/:id/accept_invitation/:invitation_code" element={<FeedbackInvitation />} />
        <Route path="/feedback/created" element={<CreatedFeedback />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
    </HotjarProvider>
  )
}

export default App
